import { getActions } from "../actions/getFiltersData";

const defaultState = {
  data: [],
  loading: false,
  error: {},
};

const getResourceReducer = (resource) => (state = defaultState, action) => {
  switch (action.type) {
    case getActions(resource).start:
      return {
        ...state,
        loading: true,
      };
    case getActions(resource).success:
      return {
        ...state,
        data: action.data,
      };
    case getActions(resource).error:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
};

const reducers = {
  donors: getResourceReducer("donors"),
  fields: getResourceReducer("fields"),
  portals: getResourceReducer("portals"),
  sdgs: getResourceReducer("sdgs"),
  oecds: getResourceReducer("oecds"),
  homeFields: getResourceReducer("homeFields"),
  homeDonors: getResourceReducer("homeDonors"),
  homeSdgs: getResourceReducer("homeSdgs"),
  homeSectors: getResourceReducer("homeSectors"),
};

export default reducers;



// WEBPACK FOOTER //
// ./shared/reducers/filtersData.js